import React from 'react'

import { Box, Icon, Text, useClassNames } from '@factorialco/deprecated-design-system'

import 'modules/onboarding/components/HelpButton/index.styles.css'

const stylesRefs = {
  itemHover: 'HelpButton_itemHover',
}

interface Props {
  title: string
  description: string
  icon?: React.ComponentProps<typeof Icon.Medium>['icon']
  onClick: () => void
}

const PopoverItem = ({ title, description, icon, onClick }: Props) => {
  const cx = useClassNames(stylesRefs)

  return (
    <Box
      component="li"
      flexDirection="row"
      gap="s16"
      onClick={onClick}
      cursor="pointer"
      paddingX="s24"
      paddingY="s8"
      className={cx('itemHover')}
    >
      {icon && (
        <Box
          background="grey400"
          borderRadius={{
            all: 'abs016',
          }}
          minWidth="s40"
          minHeight="s40"
          justifyContent="center"
          alignItems="center"
          alignSelf="center"
        >
          <Icon.Medium icon={icon} color="grey800" />
        </Box>
      )}
      <Box textAlign="left">
        <Text.Normal weight="medium" color="grey800">
          {title}
        </Text.Normal>
        <Text.Normal size="200" color="grey800">
          {description}
        </Text.Normal>
      </Box>
    </Box>
  )
}

export default PopoverItem
